var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedVmActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Vim_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vim_Active",
    clipPath: "url(#clip-Vim_Active)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Voicemail",
    d: "M178.965,88.089V88.1h17.17v-.007a6.629,6.629,0,1,0-6.893-6.623,7.555,7.555,0,0,0,.619,3.1l-4.952.006a5.731,5.731,0,0,0,1.057-3.207,6.733,6.733,0,1,0-7,6.726Zm16.908-10.443a3.823,3.823,0,1,1-3.823,3.823A3.827,3.827,0,0,1,195.872,77.645Zm-16.638-.121a3.839,3.839,0,1,1-3.839,3.839A3.844,3.844,0,0,1,179.234,77.524Z",
    transform: "translate(-171.5 -65.63)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedVmActive);
export default __webpack_public_path__ + "static/media/SharedVM_Active.97543d9a85532de7d2989a9b1943d48f.svg";
export { ForwardRef as ReactComponent };